import { render, staticRenderFns } from "./SignatureDisclosureDialog.vue?vue&type=template&id=31a0ee61&scoped=true&"
import script from "./SignatureDisclosureDialog.vue?vue&type=script&lang=js&"
export * from "./SignatureDisclosureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0ee61",
  null
  
)

export default component.exports